const LOCAL_DEV_HOSTS = new Set(['localhost', '127.0.0.1']);

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (LOCAL_DEV_HOSTS.has(window.location.hostname)) {
    return 'http://localhost:8000';
  }

  return `${window.location.origin}/api`;
};

export const buildApiUrl = (path) => {
  const base = getApiBaseUrl().replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

export const assertCsvResponse = (response) => {
  const contentType = (response.headers.get('content-type') || '').toLowerCase();
  const isCsv = contentType.includes('text/csv') || contentType.includes('application/csv');
  const isBinary = contentType.includes('application/octet-stream');
  if (!isCsv && !isBinary) {
    throw new Error(`Unexpected content type for CSV download: ${contentType || 'missing'}`);
  }
};
